import { has } from 'lodash';
import { PropModel } from '../prop.model';

export type ModelEntity = {
  action: 'allow' | 'block';
  modelId: string;
};

export class PortalConfig extends PropModel {
  enabled?: boolean;
  defaultModelId?: string;
  availablePrivateModels?: ModelEntity[];

  constructor(props?: Record<string, unknown>) {
    super();
    const data = (props || {}) as Record<keyof PortalConfig, unknown>;

    if (has(data, 'enabled')) {
      this.enabled = !!data.enabled;
    }

    if (data.defaultModelId) {
      this.defaultModelId = data.defaultModelId as string;
    }

    if (data.availablePrivateModels) {
      this.availablePrivateModels = data.availablePrivateModels as ModelEntity[];

      // legacy schema support
    } else {
      const modelIds = data.availablePrivateModelIds;

      if (Array.isArray(modelIds) && modelIds.length) {
        this.availablePrivateModels = (modelIds as string[]).map((modelId) => ({
          modelId,
          action: 'allow',
        }));
        return;
      }
    }
  }

  get availablePrivateModelIds(): string[] {
    return (this.availablePrivateModels || [])
      .filter(({ action }) => action === 'allow')
      .map(({ modelId }) => modelId);
  }
}

export type AssistantEntity = {
  action: 'allow' | 'block';
  assistantId: string;
};

export class AssistantConfig extends PropModel {
  access: AssistantEntity[];

  constructor(props?: Record<string, unknown>) {
    super();
    const data = (props || {}) as Record<keyof AssistantConfig, unknown>;
    this.access = (data.access as AssistantEntity[]) || [];
  }
}

export type DatasourceEntity = {
  action: 'allow' | 'block';
  dataSourceId: string;
};

export class DatasourceConfig extends PropModel {
  access: DatasourceEntity[];

  constructor(props?: Record<string, unknown>) {
    super();
    const data = (props || {}) as Record<keyof DatasourceConfig, unknown>;
    this.access = (data.access as DatasourceEntity[]) || [];
  }
}
